import React, { createContext, useState, useEffect, useContext } from 'react';

import UserService from '../views/User/service/index';
import { apiUc } from '../http';
export const UserTeamsContext = createContext([]);

export function MyAgentTeams({ children }) {
  const [usersMyTeams, setUsersMyTeams] = useState([]);
  const [usersInMyTeamsFullInfo, setUsersInMyTeamsFullInfo] = useState([]);

  const loadApiUsersMyTeams = () => {
    const login = localStorage.getItem('login');

    if (!login) return;

    UserService.findAgentsMyTeam(login).then((response) => {
      setUsersMyTeams(response);
    });
  };

  const loadUsers = async () => {
    const login = localStorage.getItem('login');

    if (!login) return;

    const { data } = await apiUc.get(`/api/teams-users/${login}`);

    setUsersInMyTeamsFullInfo(data.data || []);
  };

  useEffect(() => {
    loadApiUsersMyTeams();
    loadUsers();
  }, []);

  return (
    <>
      <UserTeamsContext.Provider
        value={{ usersMyTeams, loadApiUsersMyTeams, usersInMyTeamsFullInfo }}
      >
        {children}
      </UserTeamsContext.Provider>
    </>
  );
}
export function useUsersMyTeams() {
  const context = useContext(UserTeamsContext);
  return context;
}
